/* eslint-disable react/no-multi-comp */
/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
import React, {useRef, useState} from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import isEqual from 'lodash.isequal';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  Divider,
  Fab
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import SendIcon from '@material-ui/icons/Send';
import { withSnackbar } from 'notistack';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './orderfooter.css';
import {strapi} from '../../../../strapi/strapi.config';
import { selectOrderCurrentOrder, selectOrderUpdatedOrder, selectOrderOrders, selectOrderDeletedItems, selectOrderCurrentProduct } from '../../../../redux/order/order.selectors'
import { setOverlaySpinner } from '../../../../redux/other/other.actions';
import { setCurrentOrder, setUpdatedOrder, setOrdersSuccess, setDeletedItems } from '../../../../redux/order/order.actions'
import {selectCurrentUser } from '../../../../redux/user/user.selectors';
import { t } from '../../../../i18n';


const useStyles = makeStyles((theme) => ({
  alignButton:{
    display:'flex',
    justifyContent: 'flex-end' 
  },
  container: {
    width:'100%',
    display:'flex',
    flexDirection: 'row',
    justifyContent: 'space-between', 
    flexWrap:'wrap'
  },
  fab: {
    margin: theme.spacing(1),
  },
  extendedIconGreen:{
    color:'green'
  },
  extendedIconRed:{
    color:'red'
  },
  extendedIconOrange:{
    color:'orange'
  }
}));

const OrderFooter = props => {
  
  const [buttonDisabled, setButtonDisabled]=useState(false);
  const flowLockRef = useRef(false);
  const { currentOrder,updatedOrder,currentProduct,currentUser, setOrdersSuccess,orders,deletedItems,setDeletedItems, history, enqueueSnackbar, setOverlaySpinner, setCurrentOrder} = props;
  const classes = useStyles();
  const isComisionar = currentUser?.idFirma?.cfg1 === 'DA';
  const isExpozorOrder = currentProduct?.cod === 'ex';
  const getIdFirmaForPayload = ()=>{
    if (updatedOrder?.idFirma && typeof updatedOrder.idFirma === 'object') {
      return Number(updatedOrder.idFirma.id || 0)
    }
    return Number(updatedOrder?.idFirma || 0)
  }
  const getDiscountComisionar = ()=>{
    if (!currentProduct?.cod || !currentUser?.idFirma) {
      return 0
    }
    switch(currentProduct.cod){
    case 'jv':
      return Number(currentUser.idFirma.discountJV || 0)
    case 'ro':
      return Number(currentUser.idFirma.discountRO || 0)
    case 're':
      return Number(currentUser.idFirma.discountRE || 0)
    case 'ug':
      return Number(currentUser.idFirma.discountUG || 0)
    case 'pi':
      return Number(currentUser.idFirma.discountPI || 0)
    case 'jo':
      return Number(currentUser.idFirma.discountJO || 0)
    default:
      return 0
    }
  }
  const calculeazaTotaluriComanda = ()=>{
    const repere = Array.isArray(updatedOrder?.comandarepers) ? updatedOrder.comandarepers : []
    const TotalValoareCatalog = repere.reduce((accumulator, currentValue)=> {return accumulator + Number(currentValue.pretCatalog || 0);},0)
    const TotalValoareComanda = repere.reduce((accumulator, currentValue)=> {return accumulator + Number(currentValue.pretCuDiscount || 0);},0)
    const TotalValoareClientFinal = repere.reduce((accumulator, currentValue)=> {return accumulator + Number(currentValue.pretClientFinal || 0);},0)
    const TotalValoareComisionar = isComisionar ? Number((TotalValoareClientFinal - TotalValoareComanda).toFixed(2)) : 0
    return {TotalValoareCatalog, TotalValoareComanda, TotalValoareClientFinal, TotalValoareComisionar}
  }
  const payloadComanda = ()=>{
    const {TotalValoareCatalog, TotalValoareComanda, TotalValoareClientFinal, TotalValoareComisionar} = calculeazaTotaluriComanda()
    return {
      'clientClient': updatedOrder.clientClient? updatedOrder.clientClient : '',
      'valoareCatalog': updatedOrder.comandarepers? TotalValoareCatalog: 0,
      'discount': updatedOrder.discount? updatedOrder.discount : 0,
      'discountComisionar': isComisionar ? (updatedOrder.discountComisionar ?? getDiscountComisionar()) : 0,
      'cursValutar': updatedOrder.cursValutar? updatedOrder.cursValutar:0,
      'valoareComanda': updatedOrder.comandarepers? TotalValoareComanda: 0,
      'valoareClientFinal': updatedOrder.comandarepers? TotalValoareClientFinal: 0,
      'valoareComisionar': TotalValoareComisionar,
      'observatii': updatedOrder.observatii? updatedOrder.observatii :'',
      'adresaLivrare': updatedOrder.adresaLivrare? updatedOrder.adresaLivrare:'',
      'stadiu': updatedOrder.stadiu?updatedOrder.stadiu:'NETRANSMISA',
      'idFirma': getIdFirmaForPayload(),
      'tipProdus': updatedOrder.tipProdus? updatedOrder.tipProdus :'Z',
      'subTip':updatedOrder.subTip? updatedOrder.subTip :''
    }
  }
  //-------------------------------------------------------------------------------------------------------
  const jsonCopy=(src)=>{
    return JSON.parse(JSON.stringify(src));
  }
  //-------------------------------------------------------------------------------------------------------
  const logFlowError = (stage, error, details = {})=>{
    console.error('[orderFlow][error]', {
      stage,
      orderId: Number(updatedOrder?.id || 0),
      tipProdus: updatedOrder?.tipProdus || currentProduct?.cod || null,
      isExpozorOrder,
      message: error?.message || String(error),
      ...details
    });
  };
  //-------------------------------------------------------------------------------------------------------
  const runStep = async (stage, executor, details = {})=>{
    try {
      return await executor();
    } catch (error) {
      logFlowError(stage, error, details);
      throw error;
    }
  };
  //-------------------------------------------------------------------------------------------------------
  const beginFlowIfIdle = ()=>{
    if (flowLockRef.current) {
      enqueueSnackbar(t('orderFooter.saveInProgress'),{
        variant: 'warning',
        autoHideDuration:1500
      });
      return false;
    }
    flowLockRef.current = true;
    return true;
  };
  //-------------------------------------------------------------------------------------------------------
  const endFlow = ()=>{
    flowLockRef.current = false;
  };
  //-------------------------------------------------------------------------------------------------------


  //-------------------------------------------------------------------------------------------------------

  const handleCancel=()=>{
    if (isEqual(currentOrder,updatedOrder)){
      let path = '/orders';
      setCurrentOrder({})
      history.push(path);
      
    }else{
      confirmAlert({
        title: t('orderFooter.hasChangesTitle'),
        message: t('orderFooter.hasChangesMessage'),
        buttons: [
          {
            label: t('common.yes'),
            onClick: () => {
              let path = '/orders';
              setCurrentOrder({})
              history.push(path);
            }
          },
          {
            label: t('common.no'),
            onClick: () => {
              enqueueSnackbar(t('orderFooter.cancelAbandon'),{ 
                variant: 'warning',
                autoHideDuration:3000
              })    
            }
          }
        ]
      });
    }
  }
  //-------------------------------------------------------------------------------------------------------
  const upsertOrderInState = (orderRecord)=>{
    if (!orderRecord || !orderRecord.id) {
      return;
    }
    const comenzi = jsonCopy(orders || []);
    const foundComanda = comenzi.findIndex(com => com.id === orderRecord.id);
    if (foundComanda !== -1) {
      comenzi[foundComanda] = {
        ...comenzi[foundComanda],
        ...orderRecord
      };
    } else {
      comenzi.unshift(orderRecord);
    }
    setOrdersSuccess(comenzi);
  };
  //-------------------------------------------------------------------------------------------------------
  const buildReperPayload = (reper, index, orderId, includeActionare = false)=>{
    const payload = {
      idComanda: orderId,
      nrCrt: index + 1,
      tipSubprodus: reper.tipSubprodus,
      lungime: reper.lungime,
      lungimeFinala: reper.lungimeFinala,
      inaltime: reper.inaltime,
      inaltimeFinala: reper.inaltimeFinala,
      deschidere: reper.deschidere,
      culoareLamela: reper.culoareLamela,
      culoareCaseta: reper.culoareCaseta,
      material: reper.material,
      codMaterial: reper.codMaterial,
      lungimeSnur: reper.lungimeSnur,
      tipActionare: reper.tipActionare,
      actionareStDr: reper.actionareStDr,
      ax: reper.ax,
      culoareComponente: reper.culoareComponente,
      optional1: reper.optional1,
      optional2: reper.optional2,
      optional3: reper.optional3,
      optional4: reper.optional4,
      console: reper.console,
      buc: reper.buc,
      mp: reper.mp,
      pretCatalog: reper.pretCatalog,
      pretCuDiscount: reper.pretCuDiscount,
      pretClientFinal: reper.pretClientFinal,
      observatii: reper.observatii,
      tipProdus: reper.tipProdus,
      denumireProdus: reper.denumireProdus,
      denumireSubProdus: reper.denumireSubProdus,
      denumireCuloareLamela: reper.denumireCuloareLamela,
      denumireCuloareCaseta: reper.denumireCuloareCaseta,
      denumireMaterial: reper.denumireMaterial,
      denumireTipActionare: reper.denumireTipActionare,
      denumireOptional1: reper.denumireOptional1,
      denumireOptional2: reper.denumireOptional2,
      denumireOptional3: reper.denumireOptional3,
      denumireOptional4: reper.denumireOptional4,
      continePlasaPartiala: reper.continePlasaPartiala
    };
    if (includeActionare) {
      payload.actionare = reper.actionare;
    }
    return payload;
  };
  //-------------------------------------------------------------------------------------------------------
  const salvareComandaNoua = async ()=>{
    const response = await runStep(
      'create-order',
      ()=>strapi.createEntry('comandas', payloadComanda())
    );
    upsertOrderInState(response);
    return response;
  };
  //-------------------------------------------------------------------------------------------------------
  const salvareComandaModificata = async (orderId)=>{
    const response = await runStep(
      'update-order',
      ()=>strapi.updateEntry('comandas', orderId, payloadComanda()),
      {orderId}
    );
    upsertOrderInState(response);
    return response;
  };

  //-------------------------------------------------------------------------------------------------------
  const salvareReperNou = async (reper, index, orderId)=>{
    await runStep(
      'create-line',
      ()=>strapi.createEntry(
        'comandarepers',
        buildReperPayload(reper, index, orderId, true)
      ),
      {orderId, reperId: reper?.id, index}
    );
  };
  //-------------------------------------------------------------------------------------------------------
  const salvareReperModificat = async (reper, index, orderId)=>{
    await runStep(
      'update-line',
      ()=>strapi.updateEntry(
        'comandarepers',
        reper.id,
        buildReperPayload(reper, index, orderId, false)
      ),
      {orderId, reperId: reper?.id, index}
    );
  };
  //-------------------------------------------------------------------------------------------------------
  const stergereReper = async (reperId)=>{
    await runStep(
      'delete-line',
      ()=>strapi.deleteEntry('comandarepers', reperId),
      {reperId}
    );
  };
  //-------------------------------------------------------------------------------------------------------
  const sincronizeazaRepere = async (orderId)=>{
    const repereActuale = Array.isArray(updatedOrder?.comandarepers) ? updatedOrder.comandarepers : [];
    const repereInitiale = Array.isArray(currentOrder?.comandarepers) ? currentOrder.comandarepers : [];
    const repereInitialeById = repereInitiale.reduce((accumulator, reper) => {
      if (reper && reper.id > 0) {
        accumulator[reper.id] = reper;
      }
      return accumulator;
    }, {});

    for (let index = 0; index < repereActuale.length; index += 1) {
      const reper = repereActuale[index];
      if (!reper) {
        continue;
      }
      if (reper.id < 0 && reper.denumireProdus !== 'STERGE') {
        await salvareReperNou(reper, index, orderId);
        continue;
      }
      if (reper.id > 0) {
        const reperInitial = repereInitialeById[reper.id];
        if (!reperInitial || isEqual(reperInitial, reper) === false) {
          await salvareReperModificat(reper, index, orderId);
        }
      }
    }

    const repereStersePersistate = (deletedItems || []).filter(item => item && item.id > 0);
    for (const reper of repereStersePersistate) {
      await stergereReper(reper.id);
    }
  };
  //-------------------------------------------------------------------------------------------------------
  const validaComandaInainteDePersistare = ()=>{
    if (!isExpozorOrder && isComisionar && (!getIdFirmaForPayload() || getIdFirmaForPayload() === Number(currentUser?.idFirma?.id || 0))) {
      props.enqueueSnackbar(t('orderFooter.selectFinalClient'),{
        variant: 'error',
      });
      return false;
    }

    if (!isExpozorOrder && !updatedOrder.clientClient){
      props.enqueueSnackbar(t('orderFooter.missingClient'),{
        variant: 'error',
      });
      return false;
    }
    if (isExpozorOrder && !updatedOrder.adresaLivrare){
      props.enqueueSnackbar(t('orderFooter.missingDeliveryAddress'),{
        variant: 'error',
      });
      return false;
    }
    return true;
  };
  //-------------------------------------------------------------------------------------------------------
  const persistaDraftComanda = async ()=>{
    const esteComandaNoua = Number(updatedOrder?.id || 0) === 0;
    const savedOrder = esteComandaNoua
      ? await salvareComandaNoua()
      : await salvareComandaModificata(updatedOrder.id);
    await sincronizeazaRepere(savedOrder.id);
    setDeletedItems([]);
    return savedOrder;
  };
  //-------------------------------------------------------------------------------------------------------
  const handleSave= async ()=>{
    if (!beginFlowIfIdle()) {
      return;
    }
    try {
      if (!validaComandaInainteDePersistare()) {
        return;
      }

      setOverlaySpinner(true);
      setButtonDisabled(true);

      if (!isEqual(currentOrder,updatedOrder)){
        await persistaDraftComanda();
        props.enqueueSnackbar(t('orderFooter.saveSuccess'),{
          variant: 'success',
          autoHideDuration:3000
        });
      }
      setCurrentOrder({});
      history.push('/orders');
    } catch (error) {
      props.enqueueSnackbar(t('orderFooter.saveError', { error }),{
        variant: 'error',
        persist:true,
      });
    } finally {
      setButtonDisabled(false);
      setOverlaySpinner(false);
      endFlow();
    }
  };

  //-------------------------------------------------------------------------------------------------------
  const handleTrimite= async ()=>{
    if (!beginFlowIfIdle()) {
      return;
    }
    try {
      if (!validaComandaInainteDePersistare()) {
        return;
      }

      setOverlaySpinner(true);
      setButtonDisabled(true);

      let comandaPersistata = null;
      if (!isEqual(currentOrder,updatedOrder)){
        comandaPersistata = await persistaDraftComanda();
      }

      const idComanda = Number(comandaPersistata?.id || updatedOrder?.id || 0);
      if (!idComanda) {
        const idError = new Error('ID comanda invalid');
        logFlowError('resolve-order-id', idError);
        throw idError;
      }

      const comandaTransmisa = await runStep(
        'mark-transmitted',
        ()=>strapi.updateEntry('comandas', idComanda, {'stadiu': 'TRANSMISA'}),
        {orderId: idComanda}
      );
      upsertOrderInState(comandaTransmisa);
      await runStep(
        'set-new-orders-indicator',
        ()=>strapi.updateEntry('indicators',1,{'Valoare': 1}),
        {orderId: idComanda, indicatorId: 1}
      );

      props.enqueueSnackbar(t('orderFooter.sendSuccess'),{
        variant: 'success',
        autoHideDuration:3000
      });
      setCurrentOrder({});
      history.push('/orders');
    } catch (error) {
      props.enqueueSnackbar(t('orderFooter.sendError', { error }),{
        variant: 'error',
        persist:true,
      });
    } finally {
      setButtonDisabled(false);
      setOverlaySpinner(false);
      endFlow();
    }
  };

  //-------------------------------------------------------------------------------------------------------
  const trimiteComanda=async ()=>{
    confirmAlert({
      title: t('orderFooter.sendConfirmTitle'),
      message: t('orderFooter.sendConfirmMessage'),
      buttons: [
        {
          label: t('common.yes'),
          onClick: async() => {
            await handleTrimite()
          }
        },
        {
          label: t('common.no'),
          onClick: () => {
            enqueueSnackbar(t('orderFooter.sendCanceled'),{ 
              variant: 'warning',
              autoHideDuration:3000
            })    
          }
        }
      ]
    });
  }
  //----------------------------------------------------------------------------------------------------
  const vanzatorVizibilitate=()=>{
    const {currentUser}=props;
    if(currentUser.role.name==='Vanzator'){
      return false;
    }else{
      return true;
    }
  }


  return ( 
    <Card
      className={classes.alignButton}
    >
      <Divider />
      <CardContent className={classes.container}>
        <div style={{display:'flex'}}>
          <Fab 
            aria-label="like" 
            className={classes.fab} 
            disabled={currentOrder.stadiu!=='TRANSMISA' && vanzatorVizibilitate()?buttonDisabled:true}
            onClick={trimiteComanda}
            size="small"
            variant="extended"
          >
            <SendIcon 
              className={classes.extendedIconOrange} 
            />
      {t('orderFooter.send')}
          </Fab>       
        </div>
        <div style={{display:'flex'}}>
          <Fab 
            aria-label="like" 
            className={classes.fab} 
            disabled={currentOrder.stadiu!=='TRANSMISA' ?buttonDisabled:true}
            onClick={handleSave}
            size="small"
            variant="extended"
          >
            <SaveIcon className={classes.extendedIconGreen} />
            {t('orderFooter.save')}
          </Fab>        
          <Fab 
            aria-label="like" 
            className={classes.fab} 
            disabled={buttonDisabled}
            onClick={handleCancel}
            size="small"
            variant="extended"
          >
            <CancelIcon className={classes.extendedIconRed} />
            {t('orderFooter.cancel')}
          </Fab>   
        </div>        
      </CardContent>
    </Card>
  
  );
 
}

OrderFooter.propTypes = {
  className: PropTypes.string,
  currentOrder:PropTypes.object,
  deletedItems:PropTypes.array, 
  enqueueSnackbar:PropTypes.func,
  history:PropTypes.object,
  orders:PropTypes.array,
  setDeletedItems:PropTypes.func, 
  setOrdersSuccess:PropTypes.func, 
  updatedOrder:PropTypes.object
};


const mapStateToProps=state=>({
  currentUser:selectCurrentUser(state),
  currentProduct:selectOrderCurrentProduct(state),
  currentOrder:selectOrderCurrentOrder(state),
  updatedOrder:selectOrderUpdatedOrder(state),
  orders:selectOrderOrders(state),
  deletedItems:selectOrderDeletedItems(state),
})

const mapDispatchToProps=dispatch=>({
  setCurrentOrder:order=>dispatch(setCurrentOrder(order)),
  setUpdatedOrder:order=>dispatch(setUpdatedOrder(order)),
  setOrdersSuccess:orders=>dispatch(setOrdersSuccess(orders)),
  setDeletedItems:items=>dispatch(setDeletedItems(items)),
  setOverlaySpinner:bool=>dispatch(setOverlaySpinner(bool)),
})

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(withSnackbar(OrderFooter)));
